<div (click)="dimmClick()"  class="modal" [ngClass]="{'fade':visible && isFaded, 'show':visible}" [ngStyle]="{'display':(visible)?'block':'none','background-color':(visible && isFaded)?'#2d2d2d6e':''}" [class]="classes">
  <div class="modal-dialog modal-dialog-centered" (click)="preventPropagation($event)">
      <ng-content></ng-content>
  </div>
</div>
